// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-bulk-location-search-form h4{margin-bottom:1rem}.user-bulk-location-search-form .search-field .mb-3{display:inline-block;width:90%}.user-bulk-location-search-form .search-field button{float:right}", ""]);
// Exports
module.exports = exports;
